const endpoints = {
	search: '/general/search',
	createCommunication: '/general/createCommunication',
	getParentElement: '/general/getParentElement',
	getNotifications: '/notifications/getUserNotifications',
	getReminders: '/notifications/getDailyReminders',
	markNotificationAsReaded: '/notifications/markAsReaded',
	getSystemCurrencies: '/currencies/getSystemCurrencies',
	getUserAvoidEmailsOptions: '/notifications/getUserAvoidEmailsOptions',
	setUserAvoidEmails: '/notifications/setUserAvoidEmails',
	setUserProjectNotificationsConfig: '/notifications/setUserProjectNotificationsConfig',
}
export {endpoints}